import {getCaptcha, loginByUserAndPass, loginUserByOtp, sendOtp} from './thunk';

export const builderLoginByUserAndPass = (builder: any) => {
  builder.addCase(loginByUserAndPass.fulfilled, (state: any, action: any) => {
    state.logging = false;
    state.user = action.payload;
    state.loginError = '';
  });
  builder.addCase(loginByUserAndPass.pending, (state: any) => {
    state.logging = true;
    state.loginError = '';
  });
  builder.addCase(loginByUserAndPass.rejected, (state: any) => {
    state.logging = false;
    state.loginError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
};

export const builderLoginByOtp = (builder: any) => {
  builder.addCase(loginUserByOtp.pending, (state: any) => {
    state.logging = true;
    state.loginError = '';
  });
  builder.addCase(loginUserByOtp.rejected, (state: any) => {
    state.logging = false;
    state.loginError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
  builder.addCase(loginUserByOtp.fulfilled, (state: any, action: any) => {
    state.logging = false;
    state.auth = action.payload;
    state.loginError = '';
  });
};

export const builderSendOtp = (builder: any) => {
  builder.addCase(sendOtp.fulfilled, (state: any, action: any) => {
    state.sendingOtp = false;
    state.sendOtpError = action.payload?.errors;
  });
  builder.addCase(sendOtp.pending, (state: any) => {
    state.sendingOtp = true;
    state.sendOtpError = '';
  });
  builder.addCase(sendOtp.rejected, (state: any, action: any) => {
    state.sendingOtp = false;
    state.sendOtpError = action.payload.message;
  });
};

export const builderGetCaptcha = (builder: any) => {
  builder.addCase(getCaptcha.pending, (state: any) => {
    state.captchaLoading = true;
  });
  builder.addCase(getCaptcha.fulfilled, (state: any, action: any) => {
    state.captcha = action.payload.data;
    state.captchaLoading = false;
  });
  builder.addCase(getCaptcha.rejected, (state: any) => {
    state.captchaLoading = false;
  });
};
